(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawer = document.getElementById('CartDrawer');
  var drawerPanel = drawer && drawer.querySelector('.cart-drawer__panel');
  var drawerContent = drawer && drawer.querySelector('[data-cart-content]');
  var drawerStatus = drawer && drawer.querySelector('[data-cart-status]');
  var lastFocused = null;
  var cartBusy = false;
  var cartReadVersion = 0;

  document.querySelectorAll('.mobile-nav').forEach(function (menu) {
    document.addEventListener('click', function (event) {
      if (menu.open && (!menu.contains(event.target) || event.target.closest('.mobile-nav__panel a'))) menu.open = false;
    });
    menu.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
  });

  function needsSticky(button) {
    if (!button || document.body.dataset.stickyEnabled === 'false') return false;
    if (window.innerWidth >= 1024 && document.body.dataset.stickyDesktop === 'false') return false;
    var header = document.querySelector('.site-header');
    var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
    var rect = button.getBoundingClientRect();
    return rect.top < top || rect.bottom > window.innerHeight;
  }

  function reserveStickySpace(sticky, active) {
    var height = active && getComputedStyle(sticky).display !== 'none' ? sticky.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--pf-sticky-height', height + 'px');
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function escapeHtml(value) {
    var span = document.createElement('span');
    span.textContent = value == null ? '' : String(value);
    return span.innerHTML;
  }

  function germanColorTitle(value) {
    var labels = {
      'sky blue': 'Himmelblau',
      'pink': 'Rosa',
      'mustard green': 'Grün',
      'deep blue': 'Dunkelblau'
    };
    var key = String(value || '').trim().toLowerCase();
    return labels[key] || value;
  }

  function setDrawerStatus(message) {
    if (drawerStatus) drawerStatus.textContent = message || '';
  }

  function renderCart(cart) {
    if (!drawerContent) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count < 1;
    });

    if (cart.sections && cart.sections['pf-cart-contents']) {
      drawerContent.innerHTML = cart.sections['pf-cart-contents'];
      return;
    }
    if (!cart.items.length) {
      drawerContent.innerHTML = '<div class="cart-empty"><p>Dein Warenkorb ist noch leer.</p><a class="button button--secondary" href="' + root + '">Weiter entdecken</a></div>';
      return;
    }

    var items = cart.items.map(function (item) {
      var mediaFallbacks = {};
      var mediaNode = document.querySelector('[data-cart-media]');
      try { mediaFallbacks = JSON.parse(mediaNode ? mediaNode.textContent : '{}'); } catch { /* Missing optional theme media map. */ }
      var verifiedImage = drawer && drawer.dataset.verifiedMedia === 'true' && item.featured_image && item.featured_image.url;
      var imageUrl = verifiedImage || mediaFallbacks[item.handle];
      var image = imageUrl
        ? '<img src="' + escapeHtml(imageUrl + (imageUrl.indexOf('?') === -1 ? '?' : '&') + 'width=180') + '" alt="' + escapeHtml(item.product_title) + '" width="90" height="90" loading="lazy">'
        : '<div class="cart-item__placeholder" aria-hidden="true"></div>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-item__variant">' + escapeHtml(germanColorTitle(item.variant_title)) + '</p>' : '';
      var components = Array.isArray(item.item_components) ? '<ul class="pf-cart-components">' + item.item_components.map(function (component) {
        var componentTitle = component.product_title || component.title || 'Bundle Bestandteil';
        var componentVariant = component.variant_title && component.variant_title !== 'Default Title' ? ' · ' + germanColorTitle(component.variant_title) : '';
        return '<li>' + Number(component.quantity || 1) + ' × ' + escapeHtml(componentTitle + componentVariant) + '</li>';
      }).join('') + '</ul>' : '';
      if (item.handle === 'pfotenfahrt-ausflugsbundle' || item.handle === 'pfotenfahrt-ausflugsbundle-1') components = '<p class="pf-cart-set__heading">2 Produkte in jedem Set</p><ul class="pf-cart-components"><li>1 × HeckHeld Kofferraumschutzmatte · Schwarz</li><li>1 × PfotenFlasche · Wasser, Futter &amp; Kotbeutel</li></ul>';
      return '<article class="cart-item">' + image + '<div class="cart-item__info"><h3>' + escapeHtml(item.product_title) + '</h3>' + variant + components +
        '<div class="cart-item__row"><div class="quantity quantity--small" aria-label="Menge für ' + escapeHtml(item.product_title) + '">' +
        '<button type="button" data-cart-change="' + escapeHtml(item.key) + '" data-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Menge verringern">−</button>' +
        '<span aria-live="polite">' + item.quantity + '</span>' +
        '<button type="button" data-cart-change="' + escapeHtml(item.key) + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Menge erhöhen">+</button></div>' +
        '<strong>' + money(item.final_line_price, cart.currency) + '</strong></div></div></article>';
    }).join('');

    drawerContent.innerHTML = '<div class="cart-items">' + items + '</div><div class="cart-summary"><div><span>Zwischensumme</span><strong>' + money(cart.total_price, cart.currency) + '</strong></div><p>Die vollständige Preisübersicht findest du auf der Warenkorbseite. Den endgültigen Gesamtbetrag siehst du vor dem Kauf an der Kasse.</p><form action="' + root + 'cart" method="post"><button class="button button--full" type="submit" name="checkout" data-checkout>Sicher zur Kasse</button></form><a class="button button--secondary button--full" href="' + root + 'cart">Warenkorb ansehen</a><button class="cart-continue" type="button" data-cart-close>Weiter shoppen</button></div>';
  }

  function loadCart(announce) {
    if (!drawerContent) return Promise.resolve();
    var readVersion = ++cartReadVersion;
    drawerContent.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Der Warenkorb konnte nicht geladen werden.');
        return response.json();
      })
      .then(function (cart) {
        return fetch(root + '?sections=pf-cart-contents', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : {}; })
          .catch(function () { return {}; })
          .then(function (sections) { cart.sections = sections; if (readVersion === cartReadVersion) renderCart(cart); return cart; });
      })
      .then(function (cart) {
        if (announce && readVersion === cartReadVersion) setDrawerStatus(announce);
        return cart;
      })
      .catch(function () {
        if (drawerContent && readVersion === cartReadVersion) drawerContent.innerHTML = '<p class="form-message form-message--error">Der Warenkorb konnte gerade nicht geladen werden. Bitte öffne die Warenkorbseite.</p>';
      })
      .finally(function () {
        if (drawerContent && readVersion === cartReadVersion) drawerContent.removeAttribute('aria-busy');
      });
  }

  function openDrawer(announce) {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    loadCart(announce).then(function () {
      if (drawerPanel && drawer.classList.contains('is-open')) (drawerPanel.querySelector('button:not([disabled])') || drawerPanel).focus();
    });
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-checkout]')) {
      window.PfotenfahrtTracking.publish('checkout_started', {});
    }
    var open = event.target.closest('[data-cart-open]');
    if (open) {
      event.preventDefault();
      openDrawer();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }
    var change = event.target.closest('[data-cart-change]');
    if (change) {
      if (cartBusy) return;
      cartBusy = true;
      cartReadVersion += 1;
      var focusLabel = change.getAttribute('aria-label');
      var lineKey = change.dataset.cartChange;
      drawerContent.querySelectorAll('[data-cart-change]').forEach(function (button) { button.disabled = true; });
      setDrawerStatus('Warenkorb wird aktualisiert …');
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity), sections: ['pf-cart-contents'] })
      }).then(function (response) {
        if (!response.ok) throw new Error();
        return response.json();
      }).then(function (cart) {
        renderCart(cart);
        setDrawerStatus('Warenkorb aktualisiert.');
        var restored = Array.from(drawerContent.querySelectorAll('[data-cart-change]')).find(function (button) { return button.dataset.cartChange === lineKey && button.getAttribute('aria-label') === focusLabel; });
        if (drawer.classList.contains('is-open')) (restored || drawerPanel.querySelector('button')).focus();
      }).catch(function () {
        setDrawerStatus('Die Menge konnte nicht geändert werden.');
      }).finally(function () {
        cartBusy = false;
        drawerContent.querySelectorAll('[data-cart-change]').forEach(function (button) { button.disabled = false; });
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') closeDrawer();
    if (event.key === 'Tab' && drawerPanel) {
      var focusable = drawerPanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === drawerPanel)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }
  });

  function initProduct(section) {
    var json = section.querySelector('[data-product-json]');
    var form = section.querySelector('[data-product-form]');
    if (!json || !form) return;
    var data;
    try { data = JSON.parse(json.textContent); } catch { return; }

    var idInput = form.querySelector('[name="id"]');
    var variantSelect = form.querySelector('[data-variant-select]');
    var priceNodes = section.querySelectorAll('[data-product-price]');
    var availabilityNodes = section.querySelectorAll('[data-product-availability]');
    var submitButtons = section.querySelectorAll('[data-add-to-cart]');
    var message = form.querySelector('[data-product-message]');
    var optionInputs = form.querySelectorAll('[data-option-index]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var packInputs = form.querySelectorAll('[data-pack-choice]');
    var packPriceOne = form.querySelector('[data-pack-price="1"]');
    var packPriceTwo = form.querySelector('[data-pack-price="2"]');
    var packRegularTwo = form.querySelector('[data-pack-regular="2"]');
    var packSavingTwo = form.querySelector('[data-pack-saving="2"]');
    var stickyBuy = section.querySelector('.sticky-buy');
    var primaryBuy = form.querySelector('[data-primary-buy]');
    var stickyName = stickyBuy && stickyBuy.querySelector('[data-sticky-name]');
    var stickyPrice = stickyBuy && stickyBuy.querySelector('[data-sticky-price]');
    var stickyButton = stickyBuy && stickyBuy.querySelector('[data-sticky-submit]');
    var stickyPackButtons = stickyBuy ? stickyBuy.querySelectorAll('[data-sticky-pack]') : [];
    var stickyPackPriceOne = stickyBuy && stickyBuy.querySelector('[data-sticky-pack-price="1"]');
    var stickyPackPriceTwo = stickyBuy && stickyBuy.querySelector('[data-sticky-pack-price="2"]');
    var submitting = false;

    function initStickyBuy() {
      if (!stickyBuy) return;
      if (stickyBuy.parentNode !== document.body) document.body.appendChild(stickyBuy);
      if (stickyBuy.dataset.stickyReady === 'true') return;
      stickyBuy.dataset.stickyReady = 'true';
      stickyBuy.setAttribute('aria-hidden', 'true');
      var stickyControls = stickyBuy.querySelectorAll('button, a, input, select');
      var footer = document.querySelector('.site-footer');

      function setStickyActive(active) {
        stickyBuy.classList.toggle('is-active', active);
        stickyBuy.setAttribute('aria-hidden', active ? 'false' : 'true');
        stickyControls.forEach(function (control) {
          if (active) control.removeAttribute('tabindex');
          else control.setAttribute('tabindex', '-1');
        });
        document.body.classList.toggle('has-sticky-buy', active);
        reserveStickySpace(stickyBuy, active);
      }

      function updateStickyBuyVisibility() {
        var target = primaryBuy || form;
        setStickyActive(needsSticky(target));
      }

      var stickyTicking = false;
      function scheduleStickyUpdate() {
        if (stickyTicking) return;
        stickyTicking = true;
        window.requestAnimationFrame(function () {
          updateStickyBuyVisibility();
          stickyTicking = false;
        });
      }

      window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
      window.addEventListener('resize', scheduleStickyUpdate);
      stickyBuy._pfStickyCleanup = function () {
        window.removeEventListener('scroll', scheduleStickyUpdate);
        window.removeEventListener('resize', scheduleStickyUpdate);
      };
      updateStickyBuyVisibility();
    }

    function syncPackCards() {
      var selectedQuantity = Math.max(1, Number(quantityInput && quantityInput.value || 1));
      packInputs.forEach(function (input) {
        var card = input.closest('.pack-offer__option, .home-pack__option');
        if (card) card.classList.toggle('is-selected', input.checked);
      });
      stickyPackButtons.forEach(function (button) {
        var selected = Number(button.dataset.stickyPack) === selectedQuantity;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    function setPackQuantity(input) {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, Number(input.dataset.packQuantity || 1));
      syncPackCards();
      syncStickyOffer();
    }

    function syncPackFromQuantity() {
      if (!quantityInput) return;
      var quantity = Math.max(1, Math.min(Number(quantityInput.max || 99), Math.floor(Number(quantityInput.value) || 1)));
      quantityInput.value = quantity;
      packInputs.forEach(function (input) {
        input.checked = Number(input.dataset.packQuantity) === quantity;
      });
      syncPackCards();
      syncStickyOffer();
    }

    function currentVariant() {
      if (variantSelect) return data.variants.find(function (variant) { return String(variant.id) === String(variantSelect.value); });
      if (!optionInputs.length) return data.variants[0];
      var options = Array.prototype.map.call(optionInputs, function (input) { return input.value; });
      return data.variants.find(function (variant) {
        return variant.options.every(function (option, index) { return option === options[index]; });
      });
    }

    function syncStickyOffer() {
      if (!stickyBuy) return;
      var variant = currentVariant();
      if (!variant) return;
      var quantity = Math.max(1, Number(quantityInput && quantityInput.value || 1));
      var discounted = data.two_pack_discount_confirmed && quantity === 2;
      var total = discounted ? Math.round(variant.price * 2 * 0.9) : variant.price * quantity;
      if (stickyName) {
        stickyName.textContent = discounted
          ? (data.two_pack_free_shipping ? '2er-Set · 10 % + Standardversand DE gratis' : '2er-Set · 10 % Rabatt')
          : quantity + ' × ' + (data.title || 'Kofferraumschutz');
      }
      if (stickyPrice) stickyPrice.textContent = money(total, data.currency);
      if (stickyPackPriceOne) stickyPackPriceOne.textContent = money(variant.price, data.currency);
      if (stickyPackPriceTwo) stickyPackPriceTwo.textContent = money(Math.round(variant.price * 2 * 0.9), data.currency);
      if (stickyButton && !stickyButton.disabled) stickyButton.textContent = discounted ? '2er-Set sichern' : stickyButton.dataset.defaultLabel;
    }

    function updateVariant() {
      var variant = currentVariant();
      if (!variant) {
        submitButtons.forEach(function (button) { button.disabled = true; button.textContent = 'Variante nicht verfügbar'; });
        availabilityNodes.forEach(function (node) { node.textContent = 'Diese Kombination ist nicht verfügbar.'; node.dataset.state = 'unavailable'; });
        return;
      }
      idInput.value = variant.id;
      priceNodes.forEach(function (node) { node.textContent = money(variant.price, data.currency); });
      section.querySelectorAll('[data-product-compare]').forEach(function (node) { node.hidden = !(variant.compare_at_price > variant.price); node.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price, data.currency) : ''; });
      section.querySelectorAll('[data-product-saving]').forEach(function (node) { var difference = (variant.compare_at_price || 0) - variant.price; node.hidden = difference <= 0; node.textContent = difference > 0 ? money(difference, data.currency) + ' · ' + String(Math.round(difference / variant.compare_at_price * 1000) / 10).replace('.', ',') + ' % Vorteil' : ''; });
      if (variant.image) section.querySelectorAll('[data-product-image]').forEach(function (node) { node.removeAttribute('srcset'); node.removeAttribute('sizes'); node.src = variant.image; });
      if (packPriceOne) packPriceOne.textContent = money(variant.price, data.currency);
      if (packRegularTwo) packRegularTwo.textContent = money(variant.price * 2, data.currency);
      if (packPriceTwo) packPriceTwo.textContent = money(Math.round(variant.price * 2 * 0.9), data.currency);
      if (packSavingTwo) packSavingTwo.textContent = money(Math.round(variant.price * 2 * 0.1), data.currency);
      availabilityNodes.forEach(function (node) {
        var isLowStock = variant.available && variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10;
        node.textContent = variant.available
          ? (isLowStock
            ? 'Nur noch ' + variant.inventory_quantity + ' Stück im aktuellen Bestand'
            : (variant.inventory_management
              ? (variant.inventory_quantity > 0 ? 'Auf Lager' : 'Bestellbar')
              : 'Verfügbar'))
          : 'Aktuell nicht verfügbar';
        node.dataset.state = variant.available ? 'available' : 'soldout';
      });
      submitButtons.forEach(function (button) {
        button.disabled = submitting || !variant.available;
        button.textContent = submitting ? 'Wird hinzugefügt …' : variant.available ? button.dataset.defaultLabel : 'Aktuell nicht verfügbar';
      });
      syncStickyOffer();
      if (history.replaceState && document.body.classList.contains('template-product')) {
        var variantUrl = new URL(window.location.href);
        variantUrl.searchParams.set('variant', variant.id);
        history.replaceState({}, '', variantUrl.pathname + variantUrl.search + variantUrl.hash);
      }
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', updateVariant); });
    if (variantSelect) variantSelect.addEventListener('change', updateVariant);
    packInputs.forEach(function (input) {
      input.addEventListener('change', function () { setPackQuantity(input); });
    });
    stickyPackButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var quantity = Number(button.dataset.stickyPack || 1);
        var matchingInput = Array.prototype.find.call(packInputs, function (input) {
          return Number(input.dataset.packQuantity) === quantity;
        });
        if (!matchingInput) return;
        matchingInput.checked = true;
        setPackQuantity(matchingInput);
      });
    });
    syncPackCards();
    updateVariant();
    initStickyBuy();

    form.addEventListener('submit', function (event) {
      if (!window.fetch) return;
      event.preventDefault();
      if (submitting || cartBusy || !form.reportValidity()) return;
      var selectedVariant = currentVariant();
      if (!selectedVariant || !selectedVariant.available) {
        if (message) message.textContent = 'Dieses Angebot ist aktuell nicht verfügbar.';
        return;
      }
      if (message) { message.textContent = ''; message.className = 'form-message'; }
      var submittedData = new FormData(form);
      submitting = true;
      cartBusy = true;
      var mutableInputs = form.querySelectorAll('input, select');
      mutableInputs.forEach(function (input) { input.disabled = true; });
      submitButtons.forEach(function (button) { button.disabled = true; button.classList.add('is-loading'); button.textContent = 'Wird hinzugefügt …'; });
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: submittedData
      }).then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw new Error(body.description || 'Das Produkt konnte nicht hinzugefügt werden.');
          return body;
        });
      }).then(function (item) {
        window.PfotenfahrtTracking.publish('add_to_cart', { product_id: data.id, variant_id: item.variant_id, quantity: item.quantity });
        openDrawer('Zum Warenkorb hinzugefügt.');
      }).catch(function (error) {
        if (message) { message.textContent = error.message; message.className = 'form-message form-message--error'; }
      }).finally(function () {
        submitting = false;
        cartBusy = false;
        mutableInputs.forEach(function (input) { input.disabled = false; });
        updateVariant();
        submitButtons.forEach(function (button) { button.classList.remove('is-loading'); });
      });
    });

    section.querySelectorAll('[data-quantity-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = quantityInput || form.querySelector('[name="quantity"]');
        var next = Math.max(1, Number(input.value || 1) + Number(button.dataset.quantityChange));
        input.value = next;
        syncPackFromQuantity();
      });
    });

    if (quantityInput) {
      quantityInput.addEventListener('change', syncPackFromQuantity);
      quantityInput.addEventListener('input', function () { if (quantityInput.value !== '') syncPackFromQuantity(); });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[type="submit"]').click();
      });
    }

    window.PfotenfahrtTracking.publish('product_viewed', { product_id: data.id, handle: data.handle });
  }

  function initOfferBuyboxes(scope) {
    (scope || document).querySelectorAll('[data-offer-buybox]').forEach(function (section) {
      if (section.dataset.offerReady === 'true') return;
      var dataNode = section.querySelector('[data-offer-data]');
      var choices = Array.prototype.slice.call(section.querySelectorAll('[data-offer-choice]'));
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-offer-card]'));
      var media = Array.prototype.slice.call(section.querySelectorAll('[data-offer-medium]'));
      var forms = Array.prototype.slice.call(section.querySelectorAll('[data-offer-form]'));
      var price = section.querySelector('[data-offer-price]');
      var compare = section.querySelector('[data-offer-compare]');
      var saving = section.querySelector('[data-offer-saving]');
      var availability = section.querySelector('[data-offer-availability]');
      var message = section.querySelector('[data-offer-message]');
      var sticky = section.querySelector('[data-offer-sticky]');
      var stickyName = sticky && sticky.querySelector('[data-sticky-name]');
      var stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');
      var stickyImage = sticky && sticky.querySelector('[data-sticky-image]');
      var stickySaving = sticky && sticky.querySelector('[data-sticky-saving]');
      var stickyCompare = sticky && sticky.querySelector('[data-sticky-compare]');
      var stickySubmit = sticky && sticky.querySelector('[data-offer-sticky-submit]');
      var footer = document.querySelector('.site-footer');
      var data;
      try { data = JSON.parse(dataNode.textContent); } catch { return; }
      var selected = 'mat';
      var submitting = false;
      var updateSticky = function () {};

      function syncQuantity() {
        var offer = data.offers[selected];
        var form = forms.find(function (node) { return node.dataset.offerForm === selected; });
        var input = form && form.querySelector('[data-offer-quantity]');
        var quantity = Math.max(1, Math.min(Number(input && input.max || 99), Math.floor(Number(input && input.value) || 1)));
        if (input) input.value = quantity;
        var discountNote = section.querySelector('[data-quantity-discount-note]');
        if (discountNote) discountNote.hidden = quantity < 2;
        if (price) price.textContent = money(offer.price * quantity, data.currency);
        if (compare && offer.compare > offer.price) compare.textContent = money(offer.compare * quantity, data.currency);
        if (saving && offer.compare > offer.price) saving.textContent = savingLabel({ price: offer.price * quantity, compare: offer.compare * quantity });
        if (stickyPrice) stickyPrice.textContent = money(offer.price * quantity, data.currency);
        if (stickySaving) { stickySaving.textContent = savingLabel(offer); stickySaving.hidden = !(offer.compare > offer.price); }
        if (stickyCompare) { stickyCompare.textContent = offer.compare > offer.price ? money(offer.compare * quantity, data.currency) : ''; stickyCompare.hidden = !(offer.compare > offer.price); }
        if (stickyName) stickyName.textContent = (quantity > 1 ? quantity + ' × ' : '') + offer.title;
      }

      function savingLabel(offer) {
        if (!offer.compare || offer.compare <= offer.price) return '';
        var amount = offer.compare - offer.price;
        var percent = Math.round((amount / offer.compare) * 1000) / 10;
        return '−' + String(Math.round(percent)).replace('.', ',') + ' % sparen';
      }

      function selectOffer(key) {
        var offer = data.offers[key];
        if (!offer || submitting || !offer.available) return;
        selected = key;
        section.querySelectorAll('[data-offer-shipping]').forEach(function (node) { node.textContent = offer.shippingLabel || 'Versandinformationen'; });
        section.querySelectorAll('[data-offer-shipping-amount]').forEach(function (node) { node.textContent = 'Versand DE: ' + (offer.shippingAmount || 'siehe Versandinformationen'); });
        if (sticky) sticky.querySelectorAll('[data-offer-shipping]').forEach(function (node) { node.textContent = offer.shippingLabel || 'Versandinformationen'; });
        choices.forEach(function (choice) { choice.checked = choice.value === key; });
        cards.forEach(function (card) {
          var active = card.dataset.offerCard === key;
          card.classList.toggle('is-selected', active);
          var state = card.querySelector('[data-offer-state]');
          if (state) state.textContent = !data.offers[card.dataset.offerCard].available ? 'Noch nicht erhältlich' : active ? 'Ausgewählt' : 'Auswählen';
        });
        media.forEach(function (node) {
          node.hidden = node.dataset.offerMedium !== key;
          var video = node.querySelector('video');
          if (!video) return;
          if (node.hidden) video.pause();
          else if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.play().catch(function (error) { if (video._pfShowFallback) video._pfShowFallback(error); });
        });
        forms.forEach(function (form) {
          var active = form.dataset.offerForm === key;
          form.hidden = !active;
          form.classList.toggle('is-active', active);
        });
        if (price) price.textContent = money(offer.price, data.currency);
        if (compare) {
          compare.hidden = !(offer.compare > offer.price);
          compare.textContent = offer.compare > offer.price ? money(offer.compare, data.currency) : '';
        }
        if (saving) {
          var label = savingLabel(offer);
          saving.hidden = !label;
          saving.textContent = label;
        }
        if (availability) {
          availability.dataset.state = offer.available ? 'available' : 'soldout';
          availability.textContent = offer.available ? offer.title + ' verfügbar' : offer.title + ' aktuell nicht verfügbar';
        }
        if (stickyName) stickyName.textContent = offer.title;
        if (stickyPrice) stickyPrice.textContent = money(offer.price, data.currency);
        if (stickyImage) stickyImage.src = offer.image;
        if (stickySubmit) { stickySubmit.disabled = !offer.available; stickySubmit.textContent = offer.available ? 'In den Warenkorb' : 'Nicht verfügbar'; }
        if (message) message.textContent = '';
        syncQuantity();
        window.requestAnimationFrame(function () { if (typeof updateSticky === 'function') updateSticky(); });
      }

      choices.forEach(function (choice) {
        choice.addEventListener('change', function () { if (choice.checked) selectOffer(choice.value); });
      });
      section.querySelectorAll('[data-offer-quantity]').forEach(function (input) {
        input.addEventListener('change', syncQuantity);
        input.addEventListener('input', function () { if (input.value !== '') syncQuantity(); });
      });
      section.querySelectorAll('[data-card-price]').forEach(function (node) { node.textContent = money(data.offers[node.dataset.cardPrice].price, data.currency); });
      section.querySelectorAll('[data-card-saving]').forEach(function (node) { node.textContent = savingLabel(data.offers[node.dataset.cardSaving]); });
      document.querySelectorAll('[data-select-offer]').forEach(function (button) {
        button.addEventListener('click', function () { selectOffer(button.dataset.selectOffer); section.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); });
      });

      forms.forEach(function (form) {
        form.addEventListener('submit', function (event) {
          if (!window.fetch) return;
          event.preventDefault();
          var button = form.querySelector('[data-offer-submit]');
          if (!button || button.disabled || submitting || cartBusy || !form.reportValidity()) return;
          var submittedKey = form.dataset.offerForm;
          var submittedOffer = data.offers[submittedKey];
          if (!submittedOffer || !submittedOffer.available) return;
          var submittedData = new FormData(form);
          submitting = true;
          cartBusy = true;
          section.querySelectorAll('[data-offer-quantity]').forEach(function (input) { input.disabled = true; });
          choices.forEach(function (choice) { choice.disabled = true; });
          if (stickySubmit) stickySubmit.disabled = true;
          if (message) { message.textContent = ''; message.className = 'form-message'; }
          button.disabled = true;
          button.classList.add('is-loading');
          button.textContent = 'Wird hinzugefügt …';
          fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: submittedData })
            .then(function (response) { return response.json().then(function (body) { if (!response.ok) throw new Error(body.description || 'Das Angebot konnte nicht hinzugefügt werden.'); return body; }); })
            .then(function (item) {
              window.PfotenfahrtTracking.publish('add_to_cart', { product_id: item.product_id, variant_id: item.variant_id, quantity: item.quantity, offer: submittedKey });
              openDrawer(submittedKey === 'bundle' ? 'Dein Set aus Matte und Flasche wurde hinzugefügt.' : 'Kofferraumschutz zum Warenkorb hinzugefügt.');
            })
            .catch(function (error) { if (message) { message.textContent = error.message; message.className = 'form-message form-message--error'; } })
            .finally(function () {
              submitting = false;
              cartBusy = false;
              section.querySelectorAll('[data-offer-quantity]').forEach(function (input) { input.disabled = false; });
              choices.forEach(function (choice) { choice.disabled = false; });
              button.disabled = !submittedOffer.available;
              if (stickySubmit) stickySubmit.disabled = !data.offers[selected].available;
              button.classList.remove('is-loading');
              button.textContent = button.dataset.defaultLabel;
            });
        });
      });

      if (sticky) {
        if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
        var controls = sticky.querySelectorAll('button, a, input, select');
        function setStickyActive(active) {
          sticky.classList.toggle('is-active', active);
          sticky.setAttribute('aria-hidden', active ? 'false' : 'true');
          controls.forEach(function (control) { if (active) control.removeAttribute('tabindex'); else control.setAttribute('tabindex', '-1'); });
          document.body.classList.toggle('has-sticky-buy', active);
          reserveStickySpace(sticky, active);
        }
        updateSticky = function () {
          var activeForm = section.querySelector('[data-offer-form].is-active');
          var button = activeForm && activeForm.querySelector('[data-offer-submit]');
          setStickyActive(needsSticky(button));
        };
        var queued = false;
        function schedule() { if (queued) return; queued = true; window.requestAnimationFrame(function () { updateSticky(); queued = false; }); }
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
        sticky._pfStickyCleanup = function () {
          window.removeEventListener('scroll', schedule);
          window.removeEventListener('resize', schedule);
        };
        if (stickySubmit) stickySubmit.addEventListener('click', function () { var form = section.querySelector('[data-offer-form].is-active'); if (form) form.requestSubmit(); });
        updateSticky();
      }

      section.querySelectorAll('[data-offer-video]').forEach(function (video) {
        var fallback = document.createElement('img');
        fallback.src = video.poster;
        fallback.alt = 'Kofferraumschutz: Vorschaubild des freigegebenen Videos';
        fallback.width = 1536; fallback.height = 1024; fallback.hidden = true;
        video.parentNode.insertBefore(fallback, video);
        function showFallback(reason) {
          // Switching the offer deliberately pauses the video; this is not a media failure.
          if (reason && reason.name === 'AbortError') return;
          video.pause(); video.hidden = true; fallback.hidden = false;
        }
        video._pfShowFallback = showFallback;
        video.addEventListener('error', showFallback);
        video.addEventListener('playing', function () {
          if (video.parentNode.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          video.hidden = false; fallback.hidden = true;
        });
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.removeAttribute('autoplay'); showFallback(); return; }
        var request = video.play();
        if (request && typeof request.catch === 'function') request.catch(showFallback);
      });
      section.dataset.offerReady = 'true';
      var landingParams = new URL(window.location.href).searchParams;
      var requestedOffer = landingParams.get('angebot');
      var metaSource = /^(meta|facebook|instagram|fb|ig)$/i.test(landingParams.get('utm_source') || '');
      var metaReferrer = false;
      try { metaReferrer = /(^|\.)(facebook\.com|instagram\.com)$/.test(new URL(document.referrer).hostname); } catch (error) { /* Referrers can be absent. */ }
      var preferBundle = requestedOffer === 'bundle' || (requestedOffer !== 'mat' && (metaSource || landingParams.has('fbclid') || metaReferrer));
      selectOffer(preferBundle && data.offers.bundle && data.offers.bundle.available ? 'bundle' : 'mat');
    });
  }

  function initCountdowns(scope) {
    (scope || document).querySelectorAll('[data-countdown]').forEach(function (node) {
      if (node.dataset.countdownReady === 'true') return;
      var deadline = node.dataset.countdownEnd || '';
      var end = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(deadline) ? Date.parse(deadline) : NaN;
      var textNode = node.closest('.trust-bar').querySelector('[data-announcement-copy]');
      function neutral() { node.hidden = true; if (textNode) textNode.textContent = textNode.dataset.announcementNeutral || 'Bundle Vorteil sichern'; }
      var value = node.querySelector('[data-countdown-value]');
      if (!Number.isFinite(end) || end <= Date.now() || !value) { neutral(); return; }
      node.dataset.countdownReady = 'true';
      node.hidden = false;
      if (textNode) textNode.textContent = textNode.dataset.announcementActive;
      function update() {
        var remaining = Math.max(0, end - Date.now());
        if (!remaining || !node.isConnected) { neutral(); window.clearInterval(timer); return; }
        var total = Math.floor(remaining / 1000);
        var days = Math.floor(total / 86400);
        var hours = Math.floor((total % 86400) / 3600);
        var minutes = Math.floor((total % 3600) / 60);
        var seconds = total % 60;
        value.textContent = (days ? days + ' T · ' : '') + [hours, minutes, seconds].map(function (part) { return String(part).padStart(2, '0'); }).join(':');
      }
      var timer = window.setInterval(update, 1000);
      update();
    });
  }

  function initBeforeAfter(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-before-after]').forEach(function (comparison) {
      if (comparison.dataset.beforeAfterReady === 'true') return;
      var input = comparison.querySelector('[data-before-after-input]');
      var beforeLayer = comparison.querySelector('.before-after__before');
      var beforeImage = beforeLayer ? beforeLayer.querySelector('.before-after__image') : null;
      if (!input) return;

      function syncBeforeImageSize() {
        if (!beforeImage) return;
        beforeImage.style.width = comparison.clientWidth + 'px';
        beforeImage.style.height = comparison.clientHeight + 'px';
      }

      function updateComparison() {
        var value = Math.min(100, Math.max(0, Number(input.value || 50)));
        comparison.style.setProperty('--comparison-position', value + '%');
        if (beforeLayer) beforeLayer.style.width = value + '%';
        syncBeforeImageSize();
        input.setAttribute('aria-valuetext', value + ' Prozent Vorher, ' + (100 - value) + ' Prozent Nachher');
      }

      input.addEventListener('input', updateComparison);
      input.addEventListener('change', updateComparison);
      comparison.dataset.beforeAfterReady = 'true';
      updateComparison();
      if ('ResizeObserver' in window) {
        var comparisonResizeObserver = new ResizeObserver(syncBeforeImageSize);
        comparisonResizeObserver.observe(comparison);
      } else {
        window.addEventListener('resize', syncBeforeImageSize);
      }
    });
  }

  function initHeroVideos(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-home-video]').forEach(function (shell) {
      if (shell.dataset.videoReady === 'true') return;
      if (shell.matches('video')) {
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduceMotion) {
          shell.pause();
          shell.removeAttribute('autoplay');
        } else {
          var playRequest = shell.play();
          if (playRequest && typeof playRequest.catch === 'function') playRequest.catch(function () {});
        }
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) shell.pause();
          else if (!reduceMotion) {
            var resumeRequest = shell.play();
            if (resumeRequest && typeof resumeRequest.catch === 'function') resumeRequest.catch(function () {});
          }
        });
        shell.dataset.videoReady = 'true';
        return;
      }
      var video = shell.querySelector('video');
      var toggle = shell.querySelector('[data-video-toggle]');
      var label = toggle && toggle.querySelector('[data-video-toggle-label]');
      var symbol = toggle && toggle.querySelector('[aria-hidden="true"]');
      if (!video || !toggle) return;

      function updateVideoState() {
        var isPaused = video.paused;
        toggle.setAttribute('aria-label', isPaused ? 'Produktvideo abspielen' : 'Produktvideo pausieren');
        if (label) label.textContent = isPaused ? 'Abspielen' : 'Pausieren';
        if (symbol) symbol.textContent = isPaused ? '▶' : 'Ⅱ';
      }

      toggle.addEventListener('click', function () {
        if (video.paused) {
          var playRequest = video.play();
          if (playRequest && typeof playRequest.catch === 'function') {
            playRequest.catch(updateVideoState);
          }
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', updateVideoState);
      video.addEventListener('pause', updateVideoState);
      video.addEventListener('ended', updateVideoState);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
      shell.dataset.videoReady = 'true';
      updateVideoState();
    });
  }

  function initPageProgress() {
    var progress = document.querySelector('[data-page-progress] > span');
    if (!progress || progress.dataset.progressReady === 'true') return;
    progress.dataset.progressReady = 'true';
    var queued = false;
    function updateProgress() {
      var scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      var value = Math.min(1, Math.max(0, window.scrollY / scrollable));
      progress.style.transform = 'scaleX(' + value + ')';
      queued = false;
    }
    function requestProgress() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(updateProgress);
    }
    window.addEventListener('scroll', requestProgress, { passive: true });
    window.addEventListener('resize', requestProgress);
    updateProgress();
  }

  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header || header.dataset.stickyHeaderReady === 'true') return;
    header.dataset.stickyHeaderReady = 'true';
    var wrapper = header.closest('.shopify-section') || header.parentElement;
    wrapper.classList.add('site-header-wrapper');
    var queued = false;
    function updateHeader() {
      var currentY = window.scrollY;
      header.classList.toggle('is-scrolled', currentY > 8);
      wrapper.classList.remove('is-header-hidden');
      document.documentElement.style.setProperty('--pf-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
      queued = false;
    }
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(updateHeader);
    }, { passive: true });
    window.addEventListener('resize', updateHeader);
    updateHeader();
  }

  function initProofBubble() {
    var bubble = document.querySelector('[data-proof-bubble]');
    if (!bubble || bubble.dataset.proofReady === 'true') return;
    bubble.dataset.proofReady = 'true';
    var close = bubble.querySelector('[data-proof-close]');
    var primaryBuy = document.querySelector('[data-offer-submit], [data-primary-buy]');
    var primaryBuyObserver = null;
    var dismissed = false;
    try { dismissed = window.sessionStorage.getItem('pf-proof-bubble-dismissed') === 'true'; } catch {}
    if (dismissed) return;

    function showBubble() {
      if (dismissed || !bubble.hidden) return;
      bubble.hidden = false;
      window.requestAnimationFrame(function () { bubble.classList.add('is-visible'); });
    }

    window.setTimeout(function () {
      if (!primaryBuy || !('IntersectionObserver' in window)) {
        showBubble();
        return;
      }

      primaryBuyObserver = new IntersectionObserver(function (entries) {
        if (!entries[0] || entries[0].isIntersecting) return;
        primaryBuyObserver.disconnect();
        primaryBuyObserver = null;
        showBubble();
      }, { threshold: 0.15 });
      primaryBuyObserver.observe(primaryBuy);
    }, 18000);
    if (close) {
      close.addEventListener('click', function () {
        dismissed = true;
        if (primaryBuyObserver) primaryBuyObserver.disconnect();
        bubble.classList.remove('is-visible');
        window.setTimeout(function () { bubble.hidden = true; }, 240);
        try { window.sessionStorage.setItem('pf-proof-bubble-dismissed', 'true'); } catch {}
      });
    }
  }

  var revealObserver = null;

  function initReveals(scope) {
    var container = scope || document;
    container.querySelectorAll('.section, .product-hero__media, .problem-card, .benefit, .step, .product-gallery__item').forEach(function (item, index) {
      if (!item.hasAttribute('data-reveal')) item.setAttribute('data-reveal', '');
      if (!item.style.getPropertyValue('--reveal-delay') && !item.classList.contains('section')) {
        item.style.setProperty('--reveal-delay', Math.min(index * 45, 225) + 'ms');
      }
    });
    var items = container.querySelectorAll('[data-reveal]:not(.is-visible)');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) { item.classList.add('is-visible'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }

    items.forEach(function (item) { revealObserver.observe(item); });
  }

  document.querySelectorAll('[data-product-section]').forEach(initProduct);
  initOfferBuyboxes(document);
  initCountdowns(document);
  initBeforeAfter(document);
  initHeroVideos(document);
  initReveals(document);
  initPageProgress();
  initStickyHeader();
  initProofBubble();
  document.addEventListener('shopify:section:load', function (event) {
    initBeforeAfter(event.target);
    initHeroVideos(event.target);
    initReveals(event.target);
    initPageProgress();
    initStickyHeader();
    initProofBubble();
    initOfferBuyboxes(event.target);
    initCountdowns(event.target);
    if (event.target.matches('[data-product-section]') || event.target.querySelector('[data-product-section]')) {
      var productSection = event.target.matches('[data-product-section]') ? event.target : event.target.querySelector('[data-product-section]');
      initProduct(productSection);
    }
  });
  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    document.querySelectorAll('[data-sticky-owner="' + sectionId + '"]').forEach(function (sticky) {
      if (sticky._pfStickyCleanup) sticky._pfStickyCleanup();
      sticky.remove();
    });
    document.body.classList.remove('has-sticky-buy');
  });
  loadCart();
})();
